import React from 'react';
import { Wrapper, Text, Icon } from './styled';
import { icons } from './icons';

const OptionWithIcon = ({ type, description, value, text, textColor, hostname }) => {
    return (
        <Wrapper {...(type === 'price' ? { itemProp: 'offers', itemScope: true, itemType: 'http://schema.org/Offer' } : {})}>
            <Icon textColor={textColor}>
                {icons(type)}
            </Icon>
            {type === 'price' && hostname && <meta itemProp='url' content={`https://${hostname}/bundles/igrovoy`} />}
            <Text textColor={textColor}>
                {description}<br/>
                {value}&nbsp;{text}
            </Text>
            {type === 'price' && (<>
                <meta itemProp='priceCurrency' content='RUB' />
                <link itemProp='availability' href='http://schema.org/InStock' />
                <meta itemProp='priceValidUntil' content='2020-12-31' />
            </>)}
        </Wrapper>
    );
};

export default OptionWithIcon;
